import { Component, OnInit, Inject } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { mediaDB } from 'src/app/shared/tables/media';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng2SmartTableModule } from 'ng2-smart-table';


declare var $: any;
@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit {

  public files = []
  public Form: FormGroup;

  imageObj: File;
  imageUrl: null;
  submitted = false;
  message = null;
  class = null;
  action = null;

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) {
    // this.media = mediaDB.data;
  }

  ngOnInit() {
    this.Form = this.formBuilder.group({
      file: ['', Validators.required],
    })

    this.http.get<any>(this.api_endpoint+'/uploads/').subscribe(
      data => {
        this.files = data.data;
        /* data.data.map(item => {
          return {
            img: "<img src='https://hkbkeduin.s3.amazonaws.com/"+data.data.image+"' class='imgTable' >",
            file_name: data.data.image,
            url: "https://hkbkeduin.s3.amazonaws.com/"+data.data.image,
        }
      }).forEach(item => this.files.push(item)); */
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });


  }
  public settings = {
    actions: {
      position: 'right',
      add: false,
      edit: false,
      delete: false,
    },
    
    columns: {
      image: {
        title: 'Image',
        type: 'html',
      },
      imagename: {
        title: 'File Name'
      },
      url: {
        title: 'URL'
      },
      nodeurl: {
        title: 'Alternate URL'
      },
    },
  };

  public config1: DropzoneConfigInterface = {
    clickable: true,
    maxFiles: 1,
    autoReset: null,
    errorReset: null,
    cancelReset: null,
  };

  public onUploadInit(args: any): void { }

  public onUploadError(args: any): void { }

  public onUploadSuccess(args: any): void {
    window.location.reload();
   }
  

  onImagePicked(event: Event): void {
    const FILE = (event.target as HTMLInputElement).files[0];
    this.imageObj = FILE;
   }
   get f() { return this.Form.controls; }

   onImageUpload() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    const imageForm = new FormData();
    imageForm.append('image', this.imageObj);
    imageForm.append('admin', localStorage.getItem('adminName'),);
    
      // alert(this.imageObj.name);     
      this.http.get<any>(this.api_endpoint+'/uploadsfindbyimagename/'+ this.imageObj.name).subscribe(
      data => {
        console.log(data);
        if(data.data && data.data.imagename == this.imageObj.name){
          if(confirm("Image already exists, do you want to replace image?")){
            this.http.post<any>(this.api_endpoint+'/uploadToS3/', imageForm).subscribe(
            res => {
              console.log(res);
              if(res.status == '500'){
                this.message = res.message;
                this.class = 'btn btn-primary';
                return
              }else{
                this.message = 'Successfully Uploaded url: '+res.message.toLowerCase();
                this.class = 'btn btn-success';
                this.ngOnInit();
              } 
            },
            (err: HttpErrorResponse) => {
              if (err.error instanceof Error) {
                console.log("Client-side error occured.");
              } else {
                console.log("Server-side error occured.");
              }
            });
            this.http.post<any>(this.api_endpoint+'/Media/', imageForm).subscribe(
            res => {

            },
            (err: HttpErrorResponse) => {
              if (err.error instanceof Error) {
                console.log("Client-side error occured.");
              } else {
                console.log("Server-side error occured.");
              }
            });
          } 
        }else{
          this.http.post<any>(this.api_endpoint+'/uploadToS3/', imageForm).subscribe(
            res => {
              console.log(res);
              if(res.status == '500'){
                this.message = res.message;
                this.class = 'btn btn-primary';
                return
              }else{
                this.message = 'Successfully Uploaded Note:Use Alternate url';
                this.class = 'btn btn-success';
                this.ngOnInit();
              } 
            },
            (err: HttpErrorResponse) => {
              if (err.error instanceof Error) {
                console.log("Client-side error occured.");
              } else {
                console.log("Server-side error occured.");
              }
            });
            this.http.post<any>(this.api_endpoint+'/uploadToDiskstorage/', imageForm).subscribe(
              res => {
                 
              },
              (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                  console.log("Client-side error occured.");
                } else {
                  console.log("Server-side error occured.");
                }
              });
        }
        
      },
      (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
      console.log("Client-side error occured.");
      } else {
      console.log("Server-side error occured.");
      }
      });
   }

}
